module.exports = __webpack_public_path__ + "static/header-background-mob.04110400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/header-background-mob.jpg
// module id = 983
// module chunks = 114276838955818